export enum DateRangePickerPlaceholders {
  startDate = "Select start date",
  endDate = "Select end date",
}
